import { action } from "../common/Action"
import { GeographicClient } from "../generated";
const Client = new GeographicClient();
class ComuniActions {

    @action
    search(searchValue: string) {
        return Client
            .getComuniByNome(searchValue)
            .then(comuni => ({
                searchValue,
                comuni
            }));
    };
    @action
    get(codFisComune: string) {
        return Client.getComune(codFisComune);
    };
}
export default new ComuniActions();